var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAndroid)?_c('Header'):_vm._e(),_c('role'),_c('Footer'),_c('Content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }